module.exports = __webpack_public_path__ + "static/media/compareqoutes.0f6c9d2f.svg";